import { render, staticRenderFns } from "./PaperCFM.vue?vue&type=template&id=f2a2f61e&"
import script from "./PaperCFM.vue?vue&type=script&lang=js&"
export * from "./PaperCFM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports